<template lang="pug">
.sms-preview
  preview(backgroundColor="neutral100")
    preview-item.mt-0(:title="title")
      preview-iphone.mt-4.text-start
        v-row(dense)
          v-col.shrink
            v-icon(color="neutral700" size="26") mdi-chevron-left 
          v-col.grow
            div.d-flex.align-center
              v-avatar.neutral100--text.mr-2(color="#EF89A1" size="25") YZ
              div.text-2xs.neutral700--text.mr-1 Clinic name
              v-icon.mt-1(color="#25D366" size="16") mdi-check-decagram 
          v-col(cols="3")
            div.d-flex.align-center.justify-end
              v-icon(color="neutral700" size="28") mdi-video-outline
              v-icon.ml-3(color="neutral700" size="24") mdi-phone-outline
        
        div.mx-n4.mt-4.text-start
          v-divider
          div.wa-background.pa-4(:style="`background-image: url(${require('@/assets/images/wa-background.jpg')})`")
            div.d-flex.pr-6
              v-card.chat-bubble(v-if="content" flat) {{ content }}
</template>

<script>
import Preview from '@/components/review/preview/Preview.vue'
import PreviewItem from '@/components/review/preview/PreviewItem.vue'
import PreviewIphone from '@/components/review/preview/PreviewIphone.vue'

export default {
  components: { Preview, PreviewItem, PreviewIphone, },
  props: ['title', 'content'],
};
</script>

<style scoped lang="scss">
.wa-background {
  min-height: 200px;
  background-size: cover;
}
.chat-bubble {
  padding: 4px 8px 4px 8px;
  border-radius: 14px;
  &:before {
    content: "";
    position: absolute;
    top: 10%;
    left: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 15px 15px 0;
    border-color: transparent #FFFFFF transparent transparent;
  }
}
</style>
